import { axisClasses } from "@mui/x-charts/ChartsAxis";

type CartesianChartData = {
  xLabel: string;
  yLabel: string;
  abbreviatedContent: Array<{ [key: string]: any }>;
  series: { dataKey: string; label: string; color: string }[];
};

export const getCartesianChartData = (
  content: Array<{ [key: string]: any }>,
  xAxisKey: string,
  colorPalette: Array<string>,
  yAxisKey?: string,
): CartesianChartData => {
  let abbreviatedContent = content.map((item) => ({
    ...item,
    [xAxisKey]: item[xAxisKey]?.substring(0, 3), // substring first 3 chars to fit in chart
  }));

  const xLabel = toTitleCase(xAxisKey);
  const yLabel = toTitleCase(yAxisKey || "");

  const series = Object.keys(abbreviatedContent[0])
    .filter((key) => key !== xAxisKey)
    .map((key, index) => ({
      dataKey: key,
      label: toTitleCase(key),
      color: colorPalette[index % colorPalette.length],
    }));

  return { xLabel, yLabel, abbreviatedContent, series };
};

function capitalizeFirstLetter(val: string): string {
  if (val.length > 1) {
    return (
      String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase()
    );
  }
  return val.toUpperCase();
}

export const toTitleCase = (str: string): string => {
  return str
    .split("_")
    .map((word) => capitalizeFirstLetter(word))
    .join(" ");
};

export const defaultColorPalette = [
  "#A78D75", // dark pastel brown
  "#A3A49A", // dark pastel olive-gray
  "#6E4F75", // dark pastel mauve
  "#4E6D5C", // dark pastel green
  "#5A4B66", // dark pastel lavender-gray
];

export const cartesianChartStyling = {
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: "translate(-40px, 0)",
    },
  },
};
